import { CONTROLLING_CHANGE_BUCKETS, CONTROLLING_SELECT_BUCKET } from './controlling/actions';
import {
  controllingDoDefaultPreset,
  controllingDoDefaultTools,
  controllingChangeMediumWhenBucketSelected,
  controllingChangeMediumWhenBucketsChanged,
} from './controlling/reactions';
import { GLOBAL_UPDATE_PRESET_OR_PROPERTY } from './global/actions';
import { globalMapUpdate } from './global/reactions';
import { PRESETS_SET } from './presets/actions';

const reactions = {
  [PRESETS_SET]: [controllingDoDefaultTools, controllingDoDefaultPreset],
  [CONTROLLING_SELECT_BUCKET]: [controllingChangeMediumWhenBucketSelected],
  [CONTROLLING_CHANGE_BUCKETS]: [controllingChangeMediumWhenBucketsChanged],
  [GLOBAL_UPDATE_PRESET_OR_PROPERTY]: [globalMapUpdate],
};

export default reactions;
